import React from 'react';
import { makeStyles } from "@mui/styles";

import { CredentialResponse } from '../../services/Types';

const useStyles = makeStyles({
  blockedIcon: {
    color: "#D80443",
  },
  unblockedIcon: {
    color: "#53934F",
  },
});

export const UserInfoSection = ({
  userCredentials
}:{
  userCredentials: CredentialResponse
}) => {
  const classes = useStyles();
  
  return (
    <>
      {!!userCredentials?.profiles?.[0] && (
        <h2>
          {`${userCredentials?.profiles?.[0]?.firstName} ${userCredentials?.profiles?.[0]?.lastName}`}
        </h2>
      )}
      <div>
        {userCredentials?.blocks?.length ? (
          <div className="icon-text-holder">
            <i
              className={`${classes.blockedIcon} t-error`}
              data-testid="blocked-icon"
            ></i>
            <span>Blocked</span>
          </div>
        ) : (
          <div className="icon-text-holder">
            <i
              className={`${classes.unblockedIcon} t-check-circle`}
              data-testid="check-icon"
            ></i>
            <span>Unblocked</span>
          </div>
        )}
      </div>
    </>
  );
}